import * as React from 'react'
import {Nullable} from '../../../../../app/TypeHelpers'
import {NatContactAddressOnEmergency} from '../NatResidentApplicationInterface'
import {RESIDENCE_STYLE} from '../../../../../CodeMaster'
import NatResidentApplicationDetailConfirmItem from '../../common/resident/NatResidentApplicationDetailConfirmItem'
import {BlockSpacer} from '../../../../../styledComponents/ResponsiveConvenience'
import {getFormattedAddress} from '../helper/NatContactAddressOnEmergencyHelper'

interface Props {
    residenceStyle: Nullable<string>
    contactAddressOnEmergency: Nullable<NatContactAddressOnEmergency>
}

const NatResidentContactAddressOnEmergencyConfirmView = (props: Props) => {
    const {
        residenceStyle, contactAddressOnEmergency
    } = props

    if (!(residenceStyle && contactAddressOnEmergency)) {
        return <></>
    }

    const {
        familyName, firstName, zipCode, prefecture, address2,
        address3, buildingRoomNumber, fixedPhoneNumber, mobilePhoneNumber
    } = contactAddressOnEmergency


    const items = []
    switch (residenceStyle) {
        case RESIDENCE_STYLE.UNIT_OWNER.value:
        case RESIDENCE_STYLE.APPROPRIATOR_AND_TENANT.value:
            items.push(`固定電話番号：${fixedPhoneNumber}`)
            items.push(`携帯電話番号：${mobilePhoneNumber}`)
            break
        case RESIDENCE_STYLE.EXTERNAL_UNIT_OWNER.value:
            items.push(`氏名：${familyName} ${firstName}`)
            items.push(`住所：${getFormattedAddress(zipCode, prefecture, address2, address3, buildingRoomNumber)}`)
            items.push(`固定電話番号：${fixedPhoneNumber}`)
            items.push(`携帯電話番号：${mobilePhoneNumber}`)
            break
    }

    return (<>
        <NatResidentApplicationDetailConfirmItem
            title={'緊急時連絡先'}
            items={items}
        />
        <BlockSpacer height={'5px'}/>
    </>)
}

NatResidentContactAddressOnEmergencyConfirmView.displayName = 'NatResidentContactAddressOnEmergencyConfirmView'
export default NatResidentContactAddressOnEmergencyConfirmView